module.exports = __webpack_public_path__ + "img/socials-icon-dark.1204eab.svg?v=1791296779994";